module.exports = __webpack_public_path__ + "img/selected4-min.b559fdd2.png";